import { render, staticRenderFns } from "./category-ope.vue?vue&type=template&id=7fa5c87c&scoped=true&"
import script from "./category-ope.vue?vue&type=script&lang=js&"
export * from "./category-ope.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7fa5c87c",
  null
  
)

export default component.exports